import { render, staticRenderFns } from "./specialRecommend.vue?vue&type=template&id=d5da98b4&"
import script from "./specialRecommend.vue?vue&type=script&lang=js&"
export * from "./specialRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5da98b4')) {
      api.createRecord('d5da98b4', component.options)
    } else {
      api.reload('d5da98b4', component.options)
    }
    module.hot.accept("./specialRecommend.vue?vue&type=template&id=d5da98b4&", function () {
      api.rerender('d5da98b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/specialRecommend.vue"
export default component.exports